var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"app-loader"},[_c('div',{staticClass:"app-loader__overlay"}),_vm._v(" "),_c('div',{staticClass:"app-loader__progress-bar"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-448d5fde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/app-loader/app-loader.vue
// module id = xpMb
// module chunks = 0